import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppConfigService } from "../app-config.service";
import { AppError } from "../common/class/app-error";

@Injectable({
  providedIn: 'root'
})
export class ProtectedReplyService {

  constructor(private http: HttpClient,private config: AppConfigService){

  }

  uploadFile(file: File): Observable<HttpEvent<any>> {

    let url = this.config.baseApiUrl + 'api/Upload/Attachments';

    const formData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest(
      'POST',
      url,
      formData,
      {
        reportProgress: true,
        responseType: 'json'
      }
    );

    return this.http.request(req);
  }

  sendProtectedEmail(emailReqObj:any){

    const url = `${this.config.baseApiUrl}`+ 'api/v1/redact/reply';
        
         return this.http.post(url, JSON.stringify(emailReqObj), {
           headers: new HttpHeaders({
             'Content-Type': 'application/json'
           })
         }).pipe(
           catchError(this.handleError)
         );
  }

  private handleError(err: HttpErrorResponse ): Observable<AppError> {
     if(err != undefined){
     const appError = new AppError(err);
     const errorStatus = err.status;
     const errorStatusText = err.statusText;
     const error: any = err.error;
     let errorMsg = '';
  
     if (error.Message !== undefined && Array.isArray(error.Message)) {
         errorMsg = err.error.Message[0].Message;
     } else {
       if (error.error_description) {
         errorMsg = error.error_description;
       } else {
         if (error.Message) {
           errorMsg = error.Message;
         } else {
           errorMsg = errorStatusText;
         }
       }
     }
  
     const retMsg = `Error (${errorStatus}): ${errorMsg}`;
     appError.Message = retMsg;
  
     return of(appError);
   }
   }
  
}

